import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { AvailableDataServicesInterface } from '../../../../lines/models/available-data-services.interface';
import { Store } from '@ngrx/store';
import { LinesService } from '../../../../lines/services/lines.service';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { SaveMission } from '../../../store/actions/mission.actions';

@Component({
  selector: 'app-recharge-data-coriolis',
  templateUrl: './recharge-data-coriolis.component.html',
  styleUrls: ['./recharge-data-coriolis.component.css'],
  standalone: false
})
export class RechargeDataCoriolisComponent implements OnInit {
  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  customer?: CustomerInterface;

  step: number;
  availableDataServicesList: Array<AvailableDataServicesInterface>;
  selectedRecharge: AvailableDataServicesInterface|null;
  constructor(
      private store: Store<any>,
      private lineService: LinesService,
  ) { }

  ngOnInit() {
    this.step = 1;
    this.selectedRecharge = null;
    this.lineService.getAvailableDataRefillServices(this.line.offer.id).subscribe(
        response => {
          this.availableDataServicesList = response;
        }
    );
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    this.step = step;
  }

  choiceData(event: any) {
    const selectedRechargeIndex = this.availableDataServicesList.findIndex((obj) => obj.id == event.target.value);
    this.selectedRecharge = this.availableDataServicesList[selectedRechargeIndex];
  }

  checkDataChoice() {
    if (this.selectedRecharge != null) {
      this.step = 2;
    }
  }
  displayPrice(price: string) {
    const priceHt = parseFloat(price);
    if (priceHt === 0 ) {
      return priceHt;
    } else {
      if (!this.customer.siret || this.customer.siret === '') {
        return (priceHt * 1.2)
            .toFixed(2)
            .replace('.', ',') + '€ TTC';
      }
      return priceHt
          .toFixed(2)
          .replace('.', ',') + '€ HT';
    }
  }

  submit() {
    this.store.dispatch(
        new SaveMission(
            {
              refillServiceId: parseInt(this.selectedRecharge.id, 10),
              phoneNumber: this.line.phoneNumber,
            },
            this.procedureCode
        )
    );
  }
}
